import React from 'react'
import _ from "lodash";
import avatar from "../../../assets/images/profle/leadership/avatar.jpeg"
import { Rectorate, admin, deans } from "../../../data/leaders"
import head from "../../../assets/images/profle/leadership/1.jpg"
import { Link } from 'react-router-dom';

const Leadership = () => {
  return (
    <div className='flex flex-col text-black w-full place-items-center'>
      <div className='w-[80%] justify-center items-center'>

        <p className='uppercase text-5xl sm:text-2xl xs:text-2xl text-black font-bold mx-10 font-montserrat'>
          University Leadership
        </p>
        <div className='mt-5 h-[2px] bg-black w-full'></div>

        <div className='md:my-10 xl:my-10'>

       {/* Rectorate */}
          <div className='my-10'>
            <p className='text-2xl sm:text-base xs:text-base font-bold font-montserrat'>
              Rectorate - Senior Leadership
            </p>

            <div className='grid grid-cols-4 sm:grid-cols-1 xs:grid-cols-1 gap-6 my-6'>
              {Rectorate.map(ld => (
                <div
                  key={ld.id}
                  className='bg-white rounded-xl shadow-md hover:shadow-xl transition transform hover:-translate-y-1 p-5'
                >
                  <img
                    src={ld.photo}
                    alt={ld.name}
                    className='w-full h-64 object-cover rounded-lg mb-4'
                  />

                  <p className='text-lg font-semibold text-gray-900'>{ld.name}</p>
                  <p className='text-sm text-gray-600'>{ld.tiltle}</p>

                  <div className='mt-3'>
                    {ld.bio && ld.bio === "biography" ? (
                      <Link to={`${ld.bio}`} className='text-blue-600 font-medium hover:underline'>
                        Read bio
                      </Link>
                    ) : (
                      <Link to={`${ld.bio}`} state={{ bio: ld }} className='text-blue-600 font-medium hover:underline'>
                        Read bio
                      </Link>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

 {/* Deans */}
          <div className='my-10'>
            <p className='text-2xl sm:text-base xs:text-base font-bold font-montserrat'>
              Deans - Faculty Leadership
            </p>

            <div className='grid grid-cols-4 sm:grid-cols-1 xs:grid-cols-1 gap-6 my-6'>
              {deans.map(d => (
                <div
                  key={d.id}
                  className='bg-white rounded-xl shadow-md hover:shadow-xl transition transform hover:-translate-y-1 p-5'
                >
                  <img
                    src={d.photo}
                    alt={d.name}
                    className='w-full h-64 object-cover rounded-lg mb-4'
                  />

                  <p className='text-lg font-semibold text-gray-900'>{d.name}</p>
                  <p className='text-sm text-gray-600'>{d.tiltle}</p>

                  {d.bio && (
                    <div className='mt-3'>
                      <Link to={`${d.bio}`} className='text-blue-600 font-medium hover:underline'>
                        Read bio
                      </Link>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Administration */}
          <div className='my-10'>
            <p className='text-2xl sm:text-base xs:text-base font-bold font-montserrat'>
              Directors - Administration Leadership
            </p>

            <div className='grid grid-cols-4 sm:grid-cols-1 xs:grid-cols-1 gap-6 my-6'>
              {admin.map(a => (
                <div
                  key={a.id}
                  className='bg-white rounded-xl shadow-md hover:shadow-xl transition transform hover:-translate-y-1 p-5'
                >
                  <img
                    src={a.photo}
                    alt={a.name}
                    className='w-full h-64 object-cover rounded-lg mb-4'
                  />

                  <p className='text-lg font-semibold text-gray-900'>{a.name}</p>
                  <p className='text-sm text-gray-600'>{a.tiltle}</p>

                  {a.bio && (
                    <div className='mt-3'>
                      <Link to={`${a.bio}`} className='text-blue-600 font-medium hover:underline'>
                        Read bio
                      </Link>
                    </div>
                  )}
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Leadership;
